import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { convertToDecimals } from '@pharmaplan/common';
import strings from '../../../../localization';
import styles from './styles';

interface IPromoAppliedLabel {
  promoHourlyRate: number;
  totalPromoBookings: number;
  label: string;
}

const PromoAppliedLabel: FC<IPromoAppliedLabel> = ({
  promoHourlyRate,
  totalPromoBookings,
  label,
}) =>
  (
    <Box display="flex" justifyContent="center">
      <Typography sx={styles.promoLabel}>
        {strings.formatString(
          label,
        strings.formatString(
          strings.hourlyRateSuffix,
          convertToDecimals(promoHourlyRate) as string,
        ) as string,
        `${totalPromoBookings}`,
        )}
      </Typography>
    </Box>
  );

export default PromoAppliedLabel;
